import { NavLink, Link } from 'react-router-dom'
import { useAuth } from '@/lib/AuthContext'
import {
  LayoutDashboard,
  Leaf,
  MapPin,
  QrCode,
  FileCheck,
  LogOut,
  Plus,
  Factory,
  FlaskConical,
  Clock,
  User,
  Shield,
  FileText,
  ClipboardList,
  BarChart3,
} from 'lucide-react'
import { Button } from '@/components/ui/button'

const navItems = [
  { to: '/app/dashboard', label: 'Painel', icon: LayoutDashboard },
  { to: '/app/products', label: 'Produtos', icon: Leaf },
  { to: '/app/fields', label: 'Talhões', icon: MapPin },
  { to: '/app/batches', label: 'Lotes', icon: FlaskConical },
  { to: '/app/timeline', label: 'Timeline', icon: Clock },
  { to: '/app/traceability', label: 'QR Codes', icon: QrCode },
  { to: '/app/compliance', label: 'Conformidade', icon: FileCheck },
]

export function Sidebar() {
  const { signOut, profile } = useAuth()

  return (
    <div className="flex flex-col h-full">
      {/* Logo */}
      <div className="flex items-center gap-2 px-4 h-16 border-b">
        <img
          src="/logo.jpg"
          alt="AgroBio"
          width={32}
          height={32}
          className="h-8 w-8 rounded-full object-cover"
        />
        <span className="text-lg font-bold text-primary">AgroBio</span>
      </div>

      {/* CTA */}
      <div className="px-3 pt-4 pb-2">
        <Button asChild className="w-full gap-2">
          <Link to="/app/biofactory/new">
            <Plus className="h-4 w-4" />
            Comecar a rastrear
          </Link>
        </Button>
      </div>

      {/* Nav */}
      <nav className="flex-1 px-3 py-2 space-y-1">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                isActive
                  ? 'bg-primary text-primary-foreground'
                  : 'text-muted-foreground hover:bg-accent hover:text-accent-foreground'
              }`
            }
          >
            <item.icon className="h-5 w-5" />
            {item.label}
          </NavLink>
        ))}
      </nav>

      {/* Admin */}
      {profile?.role === 'admin' && (
        <div className="px-3 pb-2">
          <NavLink
            to="/app/admin/organizations"
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                isActive
                  ? 'bg-primary text-primary-foreground'
                  : 'text-muted-foreground hover:bg-accent hover:text-accent-foreground'
              }`
            }
          >
            <Shield className="h-5 w-5" />
            Admin
          </NavLink>
          <NavLink
            to="/app/admin/content"
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                isActive
                  ? 'bg-primary text-primary-foreground'
                  : 'text-muted-foreground hover:bg-accent hover:text-accent-foreground'
              }`
            }
          >
            <FileText className="h-5 w-5" />
            Conteúdo
          </NavLink>
          <NavLink
            to="/app/admin/validation"
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                isActive
                  ? 'bg-primary text-primary-foreground'
                  : 'text-muted-foreground hover:bg-accent hover:text-accent-foreground'
              }`
            }
          >
            <BarChart3 className="h-5 w-5" />
            Validação
          </NavLink>
          <NavLink
            to="/app/audit"
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                isActive
                  ? 'bg-primary text-primary-foreground'
                  : 'text-muted-foreground hover:bg-accent hover:text-accent-foreground'
              }`
            }
          >
            <ClipboardList className="h-5 w-5" />
            Auditoria
          </NavLink>
        </div>
      )}

      {/* User */}
      <div className="border-t p-4">
        <div className="flex items-center gap-3 mb-3">
          <div className="h-9 w-9 rounded-full bg-primary/10 flex items-center justify-center">
            <span className="text-sm font-semibold text-primary">
              {profile?.full_name?.charAt(0)?.toUpperCase() ?? '?'}
            </span>
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium truncate">{profile?.full_name ?? 'Usuário'}</p>
            <p className="text-xs text-muted-foreground capitalize">{profile?.role ?? ''}</p>
          </div>
        </div>
        <NavLink
          to="/app/profile"
          className={({ isActive }) =>
            `flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium transition-colors mb-2 ${
              isActive
                ? 'bg-primary text-primary-foreground'
                : 'text-muted-foreground hover:bg-accent hover:text-accent-foreground'
            }`
          }
        >
          <User className="h-4 w-4" />
          Perfil
        </NavLink>
        <Button variant="ghost" size="sm" className="w-full justify-start gap-2" onClick={signOut}>
          <LogOut className="h-4 w-4" />
          Sair
        </Button>
      </div>
    </div>
  )
}
